import type { GroupBase } from 'react-select';
import type { CreatableProps } from 'react-select/creatable';
import Creatable from 'react-select/creatable';

import type { DefaultSelectOption } from './Select';
import { getCustomSelectStyles, getSelectCommonClasses } from './Select';

export interface CreatableSelectProps<Option, IsMulti extends boolean = false>
  extends CreatableProps<Option, IsMulti, GroupBase<Option>> {}

export function CreatableSelect<OptionType = DefaultSelectOption, IsMulti extends boolean = false>({
  isMulti,
  styles,
  classNames,
  ...rest
}: CreatableSelectProps<OptionType, IsMulti>) {
  const customSelectStyles = getCustomSelectStyles<OptionType>();
  const customClasses = getSelectCommonClasses<OptionType>(isMulti);

  return (
    <Creatable
      isMulti={isMulti}
      styles={{ ...customSelectStyles, ...styles }}
      classNames={{ ...customClasses, ...classNames }}
      {...rest}
    />
  );
}
